import { PropsWithChildren } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthContext } from "@covertree/auth";
import { useQuery } from "@covertree/hooks";

interface PrivateRouteProps extends PropsWithChildren {
  allowedGroups?: string[];
  shouldBeLoggedIn: boolean;
  whenNotAllowed: (groups: string[]) => string;
  whenNotAllowedForSSO?: (provider: string) => string;
}

export const ProtectedRoute = ({
  allowedGroups,
  children,
  shouldBeLoggedIn,
  whenNotAllowed,
  whenNotAllowedForSSO,
}: PrivateRouteProps) => {
  const { isSignedIn, basicUserData } = useAuthContext();
  const query = useQuery();
  const ssoProvider = query.get("provider");

  if (shouldBeLoggedIn !== isSignedIn) {
    return ssoProvider && whenNotAllowedForSSO ? (
      <Navigate to={whenNotAllowedForSSO(ssoProvider)} replace />
    ) : (
      <Navigate to={whenNotAllowed(basicUserData?.groups ?? [])} replace />
    );
  }

  if (
    allowedGroups &&
    !allowedGroups.some((group) =>
      (basicUserData?.groups ?? []).includes(group)
    )
  ) {
    return (
      <Navigate to={whenNotAllowed(basicUserData?.groups ?? [])} replace />
    );
  }

  return children ?? <Outlet />;
};

export default ProtectedRoute;
